import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import bgImage from "../Assets/Images/Greenbg.jpg";

const stats = [
  {
    value: "96%",
    title: "Satisfaction Rate",
    desc: "Based on 356 reviews on Google",
  },
  {
    value: "25",
    title: "Certified Workers",
    desc: "Growing team of professional servicemen",
  },
  {
    value: "2M",
    title: "Insured up to $2M",
    desc: "Your home & office are safe with us",
  },
  {
    value: "80%",
    title: "Rebook Monthly",
    desc: "Special discounts for recurring clients",
  },
];

export default function AboutStatsSection() {
  return (
    <Box
      sx={{
        position: "relative",
        mt: "-150px", // overlap previous section
        pt: { xs: 8, md: 14 },
        pb: { xs: 10, md: 16 },

        /* ✅ FIXED BACKGROUND IMAGE */
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "bottom",

        borderTopLeftRadius: "60px",
        borderTopRightRadius: "60px",
        zIndex: 2,
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={6}>
          {stats.map((item, index) => (
            <Grid item xs={12} sm={6} lg={3} key={index}>
              <Box
                sx={{
                  /* ✅ CENTER ON MOBILE, LEFT ON DESKTOP */
                  textAlign: { xs: "center", lg: "left" },
                  color: "#fff",
                }}
              >
                {/* COUNTER */}
                <Typography
                  sx={{
                    fontFamily: "Inter Tight, sans-serif",
                    fontWeight: 700,
                    fontSize: { xs: "2.8rem", md: "3.6rem" },
                    lineHeight: 1,
                    mb: 1,
                  }}
                >
                  {item.value}
                </Typography>

                {/* TITLE */}
                <Typography
                  sx={{
                    fontWeight: 600,
                    mb: 1,
                    color: "#fff",
                  }}
                >
                  {item.title}
                </Typography>

                {/* DESCRIPTION */}
                <Typography
                  sx={{
                    fontSize: "0.95rem",
                    opacity: 0.85,
                    maxWidth: { xs: "100%", lg: 220 },
                    mx: { xs: "auto", lg: 0 }, // center text block on mobile
                  }}
                >
                  {item.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
